import { render, staticRenderFns } from "./MedianAverage.vue?vue&type=template&id=14c89c84&"
import script from "./MedianAverage.vue?vue&type=script&lang=js&"
export * from "./MedianAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports